import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _OAUTH_CONFIG_MAP;

import { ApiEnvs, Environment, ENVIRONMENT, HOSTNAME } from './env';
import { toPlatformPath } from './toPlatformPath';
export var OauthEnvironment;

(function (OauthEnvironment) {
  OauthEnvironment["Dev"] = "DEVELOPMENT";
  OauthEnvironment["Stage"] = "STAGE";
  OauthEnvironment["Prod"] = "PRODUCTION";
  OauthEnvironment["Unknown"] = "UNKNOWN";
})(OauthEnvironment || (OauthEnvironment = {}));

var OAUTH_CONFIG_MAP = (_OAUTH_CONFIG_MAP = {}, _defineProperty(_OAUTH_CONFIG_MAP, OauthEnvironment.Dev, {
  domain: 'peloton-dev.onepeloton-dev.auth0.com',
  audience: 'https://api-dev.onepeloton.com/',
  client_id: 'QQGA7G7m3qzsScULRl084fkssHqELk5r',
  api: 'api-api-core.dev.k8s.pelotime.com'
}), _defineProperty(_OAUTH_CONFIG_MAP, OauthEnvironment.Stage, {
  domain: 'auth-stage.onepeloton.com',
  audience: 'https://api-stage.onepeloton.com/',
  client_id: '4euOmnTzhDbzcpOUSekFSfIL2quPHFhV',
  api: 'qa1.onepeloton.com'
}), _defineProperty(_OAUTH_CONFIG_MAP, OauthEnvironment.Prod, {
  domain: 'auth.onepeloton.com',
  audience: 'https://api.onepeloton.com/',
  client_id: '8ixTesX6rJwYwds1vdWiIFb8D1Puwcux',
  api: 'api.onepeloton.com'
}), _OAUTH_CONFIG_MAP);
export var toOauthEnv = function toOauthEnv(apiEnv) {
  switch (apiEnv) {
    case ApiEnvs.Prod:
      return OauthEnvironment.Prod;

    case ApiEnvs.Qa1:
      return OauthEnvironment.Stage;

    case ApiEnvs.Local:
      return OauthEnvironment.Dev;

    default:
      return OauthEnvironment.Unknown;
  }
};
export var toOauthConfig = function toOauthConfig(env) {
  var _OAUTH_CONFIG_MAP$env;

  return (_OAUTH_CONFIG_MAP$env = OAUTH_CONFIG_MAP[env]) !== null && _OAUTH_CONFIG_MAP$env !== void 0 ? _OAUTH_CONFIG_MAP$env : {};
};

var toOauthRedirectUri = function toOauthRedirectUri() {
  var platformPath = toPlatformPath();

  switch (ENVIRONMENT) {
    case Environment.Local:
      return "https://".concat(HOSTNAME, ":3000/browse");

    default:
      return "https://".concat(HOSTNAME, "/").concat(platformPath, "/browse");
  }
};

var toOauthOrigin = function toOauthOrigin() {
  var platformPath = toPlatformPath();

  switch (ENVIRONMENT) {
    case Environment.Local:
      return "https://".concat(HOSTNAME, ":3000");

    default:
      return "https://".concat(HOSTNAME, "/").concat(platformPath);
  }
};

export var OAUTH_REDIRECT_URI = toOauthRedirectUri();
export var OAUTH_ORIGIN = toOauthOrigin();